import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./modal.html";
import { WireI18n } from '../../../modules/stores/i18nStore';
import { KEY_ESC } from '../../../modules/utilities/keyboardUtilities';
const HIDDEN_CSS_CLASS = 'modal-hidden';
class Modal extends LightningElement {
  constructor(...args) {
    super(...args);
    this.showModal = false;
    this.i18n = void 0;
    this.showClose = false;
    this.hasHeaderString = false;
    this._headerPrivate = void 0;
    this._hasRendered = false;
  }
  set header(value) {
    this.hasHeaderString = value !== '';
    this._headerPrivate = value;
  }
  get header() {
    return this._headerPrivate;
  }
  get modalHeaderCss() {
    if (this.hasHeaderString) {
      return 'slds-modal__header';
    }
    return 'slds-modal__header no-header';
  }
  show() {
    this.showModal = true;
  }
  hide() {
    this.showModal = false;
  }
  handleDialogClose() {
    //Let parent know that dialog is closed (mainly by that cross button) so it can set proper variables if needed
    const closedialog = new CustomEvent('closedialog');
    this.dispatchEvent(closedialog);
    this.hide();
  }
  handleSlotTaglineChange() {
    // Only needed in "show" state. If hiding, we're removing from DOM anyway
    // Added to address Issue #344 where querySelector would intermittently return null element on hide
    if (this.showModal === false) {
      return;
    }
    const taglineEl = this.template.querySelector('p');
    if (taglineEl) {
      taglineEl.classList.remove(HIDDEN_CSS_CLASS);
    }
  }
  handleSlotFooterChange() {
    // Only needed in "show" state. If hiding, we're removing from DOM anyway
    // Added to address Issue #344 where querySelector would intermittently return null element on hide
    if (this.showModal === false) {
      return;
    }
    const footerEl = this.template.querySelector('footer');
    if (footerEl) {
      footerEl.classList.remove(HIDDEN_CSS_CLASS);
      const content = this.template.querySelector('.modal-content');
      if (!(content !== null && content !== void 0 && content.classList.contains('content-bottom-radius-none'))) {
        content === null || content === void 0 ? void 0 : content.classList.add('content-bottom-radius-none');
      }
    }
  }
  handleKeyboard(event) {
    if (event.keyCode === KEY_ESC) {
      this.handleDialogClose();
    }
  }
  renderedCallback() {
    const content = this.template.querySelector('.modal-close');
    if (content && !this._hasRendered) {
      this._hasRendered = true;
      content === null || content === void 0 ? void 0 : content.focus();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Modal, {
  publicProps: {
    showClose: {
      config: 0
    },
    header: {
      config: 3
    }
  },
  publicMethods: ["show", "hide"],
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["showModal", "hasHeaderString", "_headerPrivate", "_hasRendered"]
});
const __lwc_component_class_internal = _registerComponent(Modal, {
  tmpl: _tmpl,
  sel: "c360-modal",
  apiVersion: 62
});
export default __lwc_component_class_internal;